/**
 * @module FE-CU51_アカウント削除画面
 */
import Header from '../../components/header/Header.vue';
import BreadCrumbList from '../../components/breadCrumb/List.vue';
import MobileFooter from '../../components/footer/MobileFooter.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import Paginate from 'vuejs-paginate';

const PAGE_ID = 'FE-CU51';

export default {
  name: 'UserDelete',
  components: {
    Header,
    BreadCrumbList,
    MobileFooter,
    PcPageTitle,
    PCFooter,
    Paginate,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU51アカウント削除画面.ユーザー情報変更'), // "アカウント削除",
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU51アカウント削除画面.C0001'), //"ユーザー様のアカウントを削除を行うことができます。\nメインユーザーとして登録されている場合はメインユーザー移譲を完了させてから削除するようにお願いいたします。",
      dialog: false,
      loginDialog: false,
      password: '',
      showPassword: false,
      isActive: true,
      text1: '',
      mail: '',
      isMainUser: true,
      users: [],
      confirmDialogUsers: [],
      totalVisiblePageItem: 3,
      page: 1,
      confirmDialogPage: 1,
      infoText: vm.$vuetify.lang.t('$vuetify.FECU51アカウント削除画面.削除の注釈表示領域'), //"本アカウントは、ホームセキュリティまたはカメラのメインユーザーであるため、サブユーザーの管理、緊急連絡先設定、IDカード／キー設定が出来なくなります。",
      infoText2: vm.$vuetify.lang.t(
        '$vuetify.FECU51アカウント削除画面.メインユーザーの権限をサブユーザーに移譲することも出来ます'
      ), //"メインユーザーの権限をサブユーザーに移譲する事もできます。再度メインユーザーが必要な場合は、メインユーザーの登録を改めて実施する必要があります。",
      infoText3: vm.$vuetify.lang.t(
        '$vuetify.FECU51アカウント削除画面.上記アカウントが削除されます'
      ), // "上記アカウントが削除されます。",
      mainUserFlag: true,
      modified: '',
      rules: {
        password: [
          (value) =>
            !!value || vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU51アカウント削除画面.E0001'),
          // "パスワードは必ず入力してください。",
        ],
      },
      listRow: 0,
      pageCount: 0,
      confirmDialogPageCount: 0,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU51アカウント削除画面.ユーザー情報変更'), // "アカウント削除",
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU51アカウント削除画面.C0001'), //"ユーザー様のアカウントを削除を行うことができます。\nメインユーザーとして登録されている場合はメインユーザー移譲を完了させてから削除するようにお願いいたします。",
        infoText: vm.$vuetify.lang.t('$vuetify.FECU51アカウント削除画面.削除の注釈表示領域'), //"本アカウントは、ホームセキュリティまたはカメラのメインユーザーであるため、サブユーザーの管理、緊急連絡先設定、IDカード／キー設定が出来なくなります。",
        infoText2: vm.$vuetify.lang.t(
          '$vuetify.FECU51アカウント削除画面.メインユーザーの権限をサブユーザーに移譲することも出来ます'
        ), //"メインユーザーの権限をサブユーザーに移譲する事もできます。再度メインユーザーが必要な場合は、メインユーザーの登録を改めて実施する必要があります。",
        infoText3: vm.$vuetify.lang.t(
          '$vuetify.FECU51アカウント削除画面.上記アカウントが削除されます'
        ), // "上記アカウントが削除されます。",
      };
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 初期表示API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    APP_CU5101: async function (param, queries, method) {
      this.$_setLoading(true);
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     userInfo: {
            //       name: '山田太郎',
            //       userId: 'test@test.co.jp',
            //     },
            //     displayDistricList: [
            //       {
            //         displayDistrictNickname: '自宅',
            //       },
            //       {
            //         displayDistrictNickname: 'リビング',
            //       },
            //       {
            //         displayDistrictNickname: '玄関',
            //       },
            //     ],
            //     cameraInfoList: [
            //       {
            //         cameraNickName: 'リビングカメラ',
            //       },
            //       {
            //         cameraNickName: '玄関カメラ',
            //       },
            //     ],
            //     modified: '2022-05-10 14:00:00',
            //   },
            // };

            // 氏名・ユーザーIDをマッピング
            this.text1 = apiData.contentsInfo.userInfo.name;
            this.mail = apiData.contentsInfo.userInfo.userId;

            // メインユーザーorサブユーザーかで表示を出し分ける
            if (
              apiData.contentsInfo.displayDistricList.length === 0 &&
              apiData.contentsInfo.cameraInfoList.length === 0
            ) {
              // サブユーザーの場合、メッセージやusersが表示されない
              this.mainUserFlag = false;
            } else {
              // メインユーザーの場合、データをマッピング
              let userList = [];
              apiData.contentsInfo.displayDistricList.forEach((element) => {
                userList.push({
                  name: element.displayDistrictNickname,
                });
              });
              apiData.contentsInfo.cameraInfoList.forEach((element) => {
                userList.push({
                  name: element.cameraNickName,
                });
              });
              userList.forEach((element, idx) => {
                this.users.push({
                  id: idx + 1,
                  name: element.name,
                });
              });
            }
            // clone users state
            this.confirmDialogUsers = JSON.parse(JSON.stringify(this.users));
            this.modified = apiData.contentsInfo.modified;
            this.pageCount = Math.ceil(this.users.length / this.listRow);
            this.confirmDialogPageCount = Math.ceil(this.confirmDialogUsers.length / this.listRow);
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      // console.log("APP_CU5101>>>");
      return apiData;
    },
    /**
     * ユーザーアカウント削除API実行処理
     */
    APP_CU5102: function () {
      this.$_setLoading(true);
      let apiData = '';
      let param = '/api/accountDelete/delete';
      // let param = "post";
      let method = 'post';

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        password: this.password,
        modified: this.modified,
      };

      this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     subUserExistCheckResult: 1,
            //   },
            // };

            if (apiData.contentsInfo.subUserExistCheckResult === 1) {
              // サブユーザー存在チェック結果 === 1の場合、Thanks画面に遷移
              sessionStorage.removeItem('token');
              this.$store.commit('setThanksType', {
                fromPageInfo: { page: 51 },
                displayType: 2,
              });
              this.$router.push('thanks');
            } else {
              // サブユーザー存在チェック結果 === 0の場合、ダイアログ表示
              this.$informationDialog('$vuetify.メッセージ一覧.FECU51アカウント削除画面.E0004');
            }
          },
          (error /* eslint-disable-line */) => {
            if (error.message.includes('400')) {
              this.$errorDialog('$vuetify.メッセージ一覧.FECU51アカウント削除画面.E0003');
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      // console.log("APP_CU5102>>>");
      return;
    },
    /**
     * 削除ボタン押下時処理
     */
    showDialog: function () {
      if (this.mainUserFlag) {
        this.dialog = true;
      } else {
        this.openLoginDialog();
      }
    },
    /**
     * アカウント削除ダイアログ表示
     */
    openLoginDialog() {
      this.dialog = false;
      this.loginDialog = true;
    },
    /**
     * アカウント削除ダイアログ非表示
     */
    closeLoginDialog() {
      this.password = '';
      this.$refs.passwordForm.reset();
      this.loginDialog = false;
    },
    /**
     * ページ番号押下時処理
     * @param {*} page ページ番号
     */
    changePage(page) {
      if (page === 1) {
        this.totalVisiblePageItem = 3;
      } else if (page >= 2 && page <= 3) {
        // show next 5 page when page is from 2 to 6
        this.totalVisiblePageItem = page + 5;
      } else if (page >= this.users - 3 && page <= this.users) {
        // show prev 5 page when page is from max-5 to max
        this.totalVisiblePageItem = this.users + 3 - page;
      } else {
        this.totalVisiblePageItem = 3;
      }
      setTimeout(() => {
        this.setPagenationTabIndex();
      }, 50);
    },
    /**
     * ページ番号押下時処理
     * (アカウント削除ダイアログ)
     * @param {*} page ページ番号
     */
    changeConfirmDialogPage(page) {
      if (page === 1) {
        this.totalVisiblePageItem = 3;
      } else if (page >= 2 && page <= 3) {
        // show next 5 page when page is from 2 to 6
        this.totalVisiblePageItem = page + 3;
      } else if (page >= this.confirmDialogUsers - 3 && page <= this.confirmDialogUsers) {
        // show prev 5 page when page is from max-5 to max
        this.totalVisiblePageItem = this.confirmDialogUsers + 3 - page;
      } else {
        this.totalVisiblePageItem = 3;
      }
      setTimeout(() => {
        this.setPagenationTabIndex();
      }, 50);
    },
    /**
     * 対象地区名・カメラ名のindexを取得
     * @param {*} i
     * @returns index
     */
    getUserIndex: function (i) {
      return i - 1 + this.listRow * (this.page - 1);
    },
    /**
     * 対象地区名・カメラ名のindexを取得
     * (アカウント削除ダイアログ)
     * @param {*} i
     * @returns index
     */
    getConfirmDialogUserIndex: function (i) {
      return i - 1 + this.listRow * (this.confirmDialogPage - 1);
    },
    /**
     * ページ番号へのタブ遷移を不可に制御
     */
    setPagenationTabIndex() {
      const elements = document.getElementsByClassName('page-number');
      for (let element of elements) {
        element.tabIndex = -1;
      }
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    if (this.$mq === 'pc') {
      this.listRow = 10;
    } else {
      this.listRow = 5;
    }

    //ローディングマーク表示と合わせて色々再見直ししたほうが良いかも
    this.isShowPage = true;

    let param = '/api/accountDelete/init';

    let queries = {
      token: sessionStorage.getItem('token'),
      terminalInfo: localStorage.getItem('terminalInfo')
        ? localStorage.getItem('terminalInfo')
        : '',
    };

    let method = 'post';

    // APP_CU5101
    await this.APP_CU5101(param, queries, method);

    this.setPagenationTabIndex();
  },
};
